import React, { useState } from 'react';
import { Tags, Package, ShoppingBag, FlaskConical, Network } from 'lucide-react';
import { useClient } from '../../contexts/ClientContext';
import Categorias from './Categorias';
import Marcas from './Marcas';
import Productos from './Productos';
import CatalogTesting from './CatalogTesting';
import ClustersView from '../admin/ClustersView';

type Tab = 'categorias' | 'marcas' | 'productos' | 'clusters' | 'testing';

interface CatalogadoProps {
  selectedTable?: string;
}

const Catalogado: React.FC<CatalogadoProps> = ({ selectedTable }) => {
  const { selectedClient } = useClient();
  const [activeTab, setActiveTab] = useState<Tab>('clusters');

  const tabs = [
    { id: 'categorias' as Tab, label: 'Categorías', icon: Tags },
    { id: 'marcas' as Tab, label: 'Marcas', icon: Package },
    { id: 'clusters' as Tab, label: 'Clusters', icon: Network },
    { id: 'productos' as Tab, label: 'Productos', icon: ShoppingBag },
    { id: 'testing' as Tab, label: 'Testeo Catalogado', icon: FlaskConical },
  ];

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">Catalogado</h1>
      
      {/* Tabs Navigation */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm
                  ${
                    activeTab === tab.id
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }
                `}
              >
                <Icon
                  className={`
                    -ml-0.5 mr-2 h-5 w-5
                    ${
                      activeTab === tab.id
                        ? 'text-blue-500'
                        : 'text-gray-400 group-hover:text-gray-500'
                    }
                  `}
                />
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="mt-6">
        {activeTab === 'categorias' && <Categorias />}
        {activeTab === 'marcas' && <Marcas />}
        {activeTab === 'clusters' && selectedClient && (
          <ClustersView 
            clientId={selectedClient.clientId} 
            clientName={selectedClient.clientName} 
          />
        )}
        {activeTab === 'productos' && <Productos />}
        {activeTab === 'testing' && <CatalogTesting selectedTable={selectedTable} />}
      </div>
    </div>
  );
};

export default Catalogado;